export default __webpack_public_path__ + "static/media/offer.d8508f92.png";